import {
	EnabledServices,
	SiteConfiguration,
} from '@matech/thebigpos-sdk'
import { FEATURES_MAP, FeatureValue } from './constants'
import { FeatureProps } from '../Features'
import { FeaturesFormFieldValues } from './FeaturesForm'

export const sortFeatures = (a: FeatureProps, b: FeatureProps) => {
	const featureKeys = Object.keys(FEATURES_MAP)
	const firstIndex = featureKeys.indexOf(a.field)
	const secondIndex = featureKeys.indexOf(b.field)
	return firstIndex - secondIndex
}

export const reduceFeatureFields = (
	data: [string, FeatureValue][]
) => {
	return data.reduce(
		(newObject, [key, value]) => {
			return {
				...newObject,
				[key]: value,
			}
		},
		{} as Record<string, FeatureValue>
	)
}

export const getSiteConfigurationFromFeaturesForm = (
	data: FeaturesFormFieldValues,
	siteConfiguration: SiteConfiguration
) => {
	const newEnabledServicesCollection: [string, FeatureValue][] = []
	const newSiteConfigurationCollection: [string, FeatureValue][] = []

	Object.entries(data).forEach(([key, value]) => {
		if (
			siteConfiguration?.enabledServices?.[
				key as keyof EnabledServices
			] !== undefined
		) {
			newEnabledServicesCollection.push([
				key,
				value.inherited ? null : value.value,
			])
		}

		if (
			siteConfiguration?.[key as keyof SiteConfiguration] !==
			undefined
		) {
			newSiteConfigurationCollection.push([
				key,
				value.inherited ? null : value.value,
			])
		}

		// Setting dependent fields to null if the main field is inherited
		if (value.inherited && FEATURES_MAP[key]?.dependentFields) {
			FEATURES_MAP[key].dependentFields.forEach((dependentField) => {
				const { field } = dependentField

				if (
					siteConfiguration?.enabledServices?.[
						field as keyof EnabledServices
					] !== undefined
				) {
					newEnabledServicesCollection.push([field, null])
				}

				if (
					siteConfiguration?.[field as keyof SiteConfiguration] !==
					undefined
				) {
					newSiteConfigurationCollection.push([field, null])
				}
			})
		}
	})

	return {
		newSiteConfiguration: reduceFeatureFields(
			newSiteConfigurationCollection
		),
		newEnabledServices: reduceFeatureFields(
			newEnabledServicesCollection
		),
	}
}

export const getDefaultFeatureValueByType = (
	type?: string
): FeatureValue => {
	if (type === 'boolean') {
		return false
	}
	if (type === 'string') {
		return ''
	}
	return null
}
